export function toNumber(value: unknown): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function toText(value: unknown): string {
  return String(value ?? '').trim();
}

export function parseDateToMs(value: string): number {
  if (!value) {
    return Date.now();
  }

  const normalized = value.replace(/\./g, '-').replace(/\//g, '-');
  const date = new Date(`${normalized}T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return Date.now();
  }
  return date.getTime();
}

export function formatDateTime(timestamp: number): string {
  const date = new Date(timestamp);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${yyyy}.${mm}.${dd} ${hh}:${min}`;
}

export function uniqueFilled(values: string[]): string[] {
  return Array.from(new Set(values.filter(Boolean)));
}
